import { combineReducers } from "redux";
import rolesReducer from "./roles";
import staffGroupsReducer from "./staffGroups";
import outletsReducer from "./outlets";
import complaincesReducer from "./compliances";
import usersReducer from "./users";
import teamsReducer from "./teams";
import foodItemsreducer from "./foodItems";
import organisationReducer from "./organisation";
import assetsReducer from "./assets";
import contractorsReducer from "./contractors";
import toiletsReducer from "./toilets";
import fireChecksReducer from "./fireChecks";
import zonesReducer from "./zones";
import contractorsSuppliersReducer from "./contractorsSuppliers";
import lineManagerReducer from "./lineManager";
import generalManagerDashboardReducer from "./generalManagerDashboard";
import checklistsReducer from "./checklists";
import docketsReducer from "./dockets";
import businessHourReducer from "./businessHours";
import tilesReducer from "./tiles";
import tasksReducer from "./tasks";
import serviceLineReducer from "./serviceLine";
import drillDownReducer from "./drillDown";
import shiftReducer from "./shifts";
import foodItemsConfigReducer from "./foodItemsconfigurations";
import auditsReducer from "./audits";
import loginReducer from "./login";
import companyStructureReducer from "./companyStructure";
import stakeholderReducer from "./stakeholder";
import tagsReducer from "./tags";
import attributesReducer from "./attributes";
import outletTargetingRulesReducer from "./outlet_targeting_rules";
import systemAuditLogsReducer from "./system_audit_logs";

export default combineReducers({
  rolesReducer,
  staffGroupsReducer,
  outletsReducer,
  complaincesReducer,
  usersReducer,
  teamsReducer,
  foodItemsreducer,
  organisationReducer,
  assetsReducer,
  contractorsReducer,
  toiletsReducer,
  fireChecksReducer,
  zonesReducer,
  contractorsSuppliersReducer,
  lineManagerReducer,
  generalManagerDashboardReducer,
  checklistsReducer,
  docketsReducer,
  businessHourReducer,
  tilesReducer,
  tasksReducer,
  serviceLineReducer,
  drillDownReducer,
  shiftReducer,
  foodItemsConfigReducer,
  auditsReducer,
  loginReducer,
  companyStructureReducer,
  stakeholderReducer,
  tagsReducer,
  attributesReducer,
  outletTargetingRulesReducer,
  systemAuditLogsReducer,
});
